/**
 * site.ts
 * Hostname split between the marketing site and the app (standard SaaS layout).
 *
 *   catty.joinedupdata.io  → marketing only (AboutPage at /, plus /terms and /privacy)
 *   catty.api-jud.io       → the app (auth, API, cookies, OAuth redirect URIs all live here)
 *
 * Both hostnames are aliases of the same CloudFront distribution, so the same
 * bundle is served; the SPA decides at runtime which role it is playing.
 */

export const MARKETING_HOST = 'catty.joinedupdata.io';
export const APP_ORIGIN = 'https://catty.api-jud.io';

/** True when the SPA is being served from the brand-domain marketing host. */
export function isMarketingHost(): boolean {
  return typeof window !== 'undefined' && window.location.hostname === MARKETING_HOST;
}

/**
 * Absolute URL into the app for a given SPA path. On the app host this is just
 * the path (so react-router can handle it client-side); on the marketing host it
 * points across to the app origin.
 */
export function appUrl(path: string): string {
  return isMarketingHost() ? `${APP_ORIGIN}${path}` : path;
}
